import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	card: {
		border: "1px solid #ece8f3",
		borderRadius: "12px",
		padding: "18px 20px",
		backgroundColor: "#fff"
	},
	cardHeader: {
		display: "flex",
		alignItems: "flex-start",
		gap: "16px"
	},
	cardHeaderText: {
		display: "flex",
		flexDirection: "column",
		gap: "4px",
		flex: 1,
		minWidth: 0
	},
	activeBadge: {
		padding: "4px 10px",
		borderRadius: "10px",
		backgroundColor: "#efe9fb",
		whiteSpace: "nowrap",
		flex: "none"
	},
	groupsList: {
		display: "flex",
		flexDirection: "column",
		gap: "12px",
		marginTop: "16px"
	},
	groupCard: {
		border: "1px solid #ece8f3",
		borderRadius: "12px",
		overflow: "hidden",
		backgroundColor: "#fff"
	},
	groupHeader: {
		display: "flex",
		alignItems: "center",
		gap: "14px",
		padding: "14px 16px",
		cursor: "pointer"
	},
	groupLabelColumn: {
		display: "flex",
		flexDirection: "column",
		flex: 1,
		minWidth: 0
	},
	countBadge: {
		padding: "3px 9px",
		borderRadius: "10px",
		backgroundColor: "#f1eef6",
		whiteSpace: "nowrap",
		flex: "none"
	},
	chevron: {
		color: "#7a7588",
		fontSize: "16px",
		flex: "none",
		transition: "transform 0.15s"
	},
	chevronExpanded: {
		transform: "rotate(180deg)"
	},
	groupBody: {
		borderTop: "1px solid #ece8f3",
		backgroundColor: "#fbfafd",
		padding: "14px 16px 16px"
	},
	queueList: {
		border: "1px solid #ece8f3",
		borderRadius: "10px",
		overflow: "hidden"
	},
	queueRow: {
		display: "flex",
		alignItems: "center",
		gap: "16px",
		padding: "13px 14px",
		cursor: "pointer",
		backgroundColor: "#fff",
		"&:not(:first-child)": {
			borderTop: "1px solid #ece8f3"
		}
	},
	queueInfo: {
		display: "flex",
		flexDirection: "column",
		gap: "2px",
		flex: 1,
		minWidth: 0
	},
	queueLabelRow: {
		display: "flex",
		alignItems: "center",
		gap: "8px"
	},
	queueCodeBadge: {
		padding: "2px 6px",
		borderRadius: "6px",
		backgroundColor: "#f4f2f8",
		whiteSpace: "nowrap"
	},
	checkboxRoot: {
		padding: 0,
		flex: "none"
	},
	checkbox: {
		width: 18,
		height: 18,
		borderRadius: "4px",
		boxSizing: "border-box"
	},
	checkboxUnchecked: {
		border: "1.5px solid #8a8599",
		backgroundColor: "#fff"
	},
	checkboxChecked: {
		border: "1.5px solid #6c4cf1",
		backgroundColor: "#6c4cf1",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	warningBanner: {
		display: "flex",
		alignItems: "flex-start",
		gap: "8px",
		backgroundColor: "#fdf6e0",
		borderRadius: "10px",
		padding: "11px 13px",
		marginTop: "14px"
	},
	warningIcon: {
		color: "#c99700",
		fontSize: "16px",
		marginTop: "1px",
		flex: "none"
	}
})

export default useStyles
